module.exports = __webpack_public_path__ + "img/poulpie.8b4cec20.png";